// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webcam-background-settings {
  display: flex;
  flex-direction: column;
  gap: var(--input-element-gap);
}

.webcam-background-library {
  display: flex;
  flex-direction: column;
  gap: var(--input-element-gap);
  min-width: 0;
  padding: var(--input-element-gap);
  border: 1px solid var(--light-grey);
  border-radius: var(--dialog-border-radius);
}

.webcam-background-library-header {
  display: flex;
  align-items: center;
  gap: var(--input-element-gap-small);
}

.webcam-background-library-header h3 {
  margin: 0;
  font-size: var(--font-size-m);
  font-weight: 600;
}

.webcam-background-count {
  padding: 1px 8px;
  border-radius: var(--dialog-border-radius);
  background-color: var(--extra-light-blue-background-color);
  font-size: var(--font-size-s);
  color: var(--info-color);
}

.webcam-background-hint,
.webcam-background-empty {
  margin: 0;
  font-size: var(--font-size-s);
  line-height: 1.5;
  color: var(--dark-grey);
}

.webcam-background-empty {
  padding: var(--input-element-gap) 0;
  font-size: var(--font-size-m);
}

.webcam-background-upload {
  align-self: flex-start;
  max-width: 100%;
  min-width: 0;
  height: auto;
  min-height: var(--input-element-height);
  padding: var(--input-element-gap-small) var(--font-size-m);
  font-size: var(--font-size-m);
  white-space: normal;
}

.webcam-background-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(140px, 100%), 1fr));
  gap: var(--input-element-gap);
}

.webcam-background-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid var(--light-grey);
  border-radius: var(--dialog-border-radius);
  background-color: var(--input-background-color);
}

.webcam-background-card[data-selected="true"] {
  border-color: var(--info-color);
  box-shadow: 0 0 0 1px var(--info-color);
  background-color: var(--extra-light-blue-background-color);
}

.webcam-background-select {
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 0;
  min-width: 0;
  width: 100%;
  border-radius: var(--dialog-border-radius);
  align-items: stretch;
}

.webcam-background-library button:focus-visible {
  outline: 2px solid var(--info-color);
  outline-offset: 3px;
}

.webcam-background-thumbnail {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: calc(var(--dialog-border-radius) - 1px) calc(var(--dialog-border-radius) - 1px) 0 0;
  background-color: var(--extra-light-grey);
}

.webcam-background-select img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.webcam-background-selected {
  position: absolute;
  right: var(--input-element-gap-small);
  bottom: var(--input-element-gap-small);
  padding: 2px 8px;
  border-radius: var(--tiny-border-radius);
  background-color: var(--input-highlight-background-color);
  color: var(--text-contrast-color);
  font-size: var(--font-size-s);
}

.webcam-background-name {
  display: block;
  padding: var(--input-element-gap-small);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--font-size-m);
  text-align: left;
}

.webcam-background-delete {
  align-self: flex-end;
  height: auto;
  min-height: 32px;
  min-width: 0;
  padding: 4px var(--input-element-gap);
  margin: 0 2px 2px;
  font-size: var(--font-size-s);
  color: var(--dark-grey);
}

.webcam-background-delete:hover:not(:disabled) {
  color: var(--error-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/device-settings/camera-select/WebcamBackgroundSettings.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,iCAAiC;EACjC,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,0DAA0D;EAC1D,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,0DAA0D;EAC1D,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mCAAmC;EACnC,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kGAAkG;EAClG,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;EAChB,wCAAwC;EACxC,yDAAyD;EACzD,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".webcam-background-settings {\n  display: flex;\n  flex-direction: column;\n  gap: var(--input-element-gap);\n}\n\n.webcam-background-library {\n  display: flex;\n  flex-direction: column;\n  gap: var(--input-element-gap);\n  min-width: 0;\n  padding: var(--input-element-gap);\n  border: 1px solid var(--light-grey);\n  border-radius: var(--dialog-border-radius);\n}\n\n.webcam-background-library-header {\n  display: flex;\n  align-items: center;\n  gap: var(--input-element-gap-small);\n}\n\n.webcam-background-library-header h3 {\n  margin: 0;\n  font-size: var(--font-size-m);\n  font-weight: 600;\n}\n\n.webcam-background-count {\n  padding: 1px 8px;\n  border-radius: var(--dialog-border-radius);\n  background-color: var(--extra-light-blue-background-color);\n  font-size: var(--font-size-s);\n  color: var(--info-color);\n}\n\n.webcam-background-hint,\n.webcam-background-empty {\n  margin: 0;\n  font-size: var(--font-size-s);\n  line-height: 1.5;\n  color: var(--dark-grey);\n}\n\n.webcam-background-empty {\n  padding: var(--input-element-gap) 0;\n  font-size: var(--font-size-m);\n}\n\n.webcam-background-upload {\n  align-self: flex-start;\n  max-width: 100%;\n  min-width: 0;\n  height: auto;\n  min-height: var(--input-element-height);\n  padding: var(--input-element-gap-small) var(--font-size-m);\n  font-size: var(--font-size-m);\n  white-space: normal;\n}\n\n.webcam-background-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(140px, 100%), 1fr));\n  gap: var(--input-element-gap);\n}\n\n.webcam-background-card {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  border: 1px solid var(--light-grey);\n  border-radius: var(--dialog-border-radius);\n  background-color: var(--input-background-color);\n}\n\n.webcam-background-card[data-selected=\"true\"] {\n  border-color: var(--info-color);\n  box-shadow: 0 0 0 1px var(--info-color);\n  background-color: var(--extra-light-blue-background-color);\n}\n\n.webcam-background-select {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  gap: 0;\n  min-width: 0;\n  width: 100%;\n  border-radius: var(--dialog-border-radius);\n  align-items: stretch;\n}\n\n.webcam-background-library button:focus-visible {\n  outline: 2px solid var(--info-color);\n  outline-offset: 3px;\n}\n\n.webcam-background-thumbnail {\n  position: relative;\n  display: block;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  border-radius: calc(var(--dialog-border-radius) - 1px) calc(var(--dialog-border-radius) - 1px) 0 0;\n  background-color: var(--extra-light-grey);\n}\n\n.webcam-background-select img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.webcam-background-selected {\n  position: absolute;\n  right: var(--input-element-gap-small);\n  bottom: var(--input-element-gap-small);\n  padding: 2px 8px;\n  border-radius: var(--tiny-border-radius);\n  background-color: var(--input-highlight-background-color);\n  color: var(--text-contrast-color);\n  font-size: var(--font-size-s);\n}\n\n.webcam-background-name {\n  display: block;\n  padding: var(--input-element-gap-small);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: var(--font-size-m);\n  text-align: left;\n}\n\n.webcam-background-delete {\n  align-self: flex-end;\n  height: auto;\n  min-height: 32px;\n  min-width: 0;\n  padding: 4px var(--input-element-gap);\n  margin: 0 2px 2px;\n  font-size: var(--font-size-s);\n  color: var(--dark-grey);\n}\n\n.webcam-background-delete:hover:not(:disabled) {\n  color: var(--error-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
